<template>
  <el-pagination
      v-bind="$attrs"
      v-on="$listeners"
      :background="background"
      :layout="layout"
      :pager-count="pagerCount"
      :total="total">
  </el-pagination>
</template>

<script>
  export default {
    name: "gj-pagination",
    props: {
      background: {
        type: Boolean,
        default: true
      },
      layout: {
        type: String,
        default: 'total, sizes, prev, pager, next, jumper',
      },
      pagerCount: {
        type: Number,
        default: 5,
      },
      total: {
        type: Number,
        default: 0
      }
    }
  }
</script>

<style lang="scss" scoped>
  
</style>
